var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',_vm._b({attrs:{"width":"200","src":require("@/assets/images/logo/logo_grupovia_white.png")}},'b-img',_vm.mainProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }